import { render } from "./ParameterCard.vue?vue&type=template&id=14120914&scoped=true&ts=true"
import script from "./ParameterCard.vue?vue&type=script&lang=ts"
export * from "./ParameterCard.vue?vue&type=script&lang=ts"

import "./ParameterCard.vue?vue&type=style&index=0&id=14120914&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14120914"]])

export default __exports__